import newsTicker from '../../../../../../src/js/modules/newsTicker';

window.addEventListener('load', () => {
    newsTicker.init();
});
